/**
 * When the console offers "Make highly available", and what it says when it does not.
 *
 * ⚠️ ITS OWN MODULE, WITH NO IMPORTS, ON PURPOSE. Living in UpgradeToHaModal.tsx it could not be
 *    tested at all: importing that file drags in axiosInstance and keycloak-js, which CRA's jest
 *    does not transform, so the suite died on `Unexpected token export` before running a single
 *    case. This is exactly the rule most worth checking mechanically (a trial user must see the
 *    option LOCKED with the reason, never hidden and never accepted), so the dependency had to
 *    go rather than the test. Same reasoning as the backend's upgradeCredentialGuard.
 */
/** The shape both datastore pages have in common, as far as this action cares. */
export interface HaUpgradeRow {
    ha?: boolean;
    status: string;
    /** Derived server-side and bounded by the workflow's own run timeout, so it cannot stick. */
    ha_upgrade_in_progress?: boolean;
}

/**
 * The "Make highly available" entry for a row's Actions menu, or `null` when the row is already
 * highly available and the entry would be meaningless.
 *
 * ⛔ LOCKED, NOT HIDDEN, AND NEVER SILENTLY ACCEPTED. A trial user who cannot see the option
 *    cannot learn it exists; one who clicks it and gets a 402 has been walked into a dead end. So
 *    the entry is always rendered with the reason IN THE LABEL, because a disabled react-select
 *    option has nowhere else to put one, and a tooltip nobody hovers is not a hint.
 */
export const haUpgradeOption = (
    row: HaUpgradeRow, isTrial: boolean,
): { value: string; label: string; isDisabled?: boolean } | null => {
    if (row.ha) return null;
    if (row.ha_upgrade_in_progress) {
        return { value: 'upgrade-ha', label: 'Upgrading to high availability…', isDisabled: true };
    }
    if (isTrial) {
        return { value: 'upgrade-ha', label: 'Make highly available · connect a card', isDisabled: true };
    }
    if (row.status !== 'ready') {
        // The API refuses this too, and says why. Refusing here as well saves a round trip and,
        // more to the point, stops the console offering an action it knows will be rejected.
        return { value: 'upgrade-ha', label: 'Make highly available · wait until ready', isDisabled: true };
    }
    return { value: 'upgrade-ha', label: 'Make highly available' };
};
